import { render, staticRenderFns } from "./intelligence.vue?vue&type=template&id=19b85d6b&scoped=true"
import script from "./intelligence.vue?vue&type=script&lang=js"
export * from "./intelligence.vue?vue&type=script&lang=js"
import style0 from "./intelligence.vue?vue&type=style&index=0&id=19b85d6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b85d6b",
  null
  
)

export default component.exports